module.exports = __webpack_public_path__ + "static/media/CLC_cover_05.b374eeb4.jpg";